import { type SvgProps, SvgWrapper } from '../utils';
export function PublishIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M19 2.25C19.4142 2.25 19.75 2.58579 19.75 3C19.75 3.41421 19.4142 3.75 19 3.75H5C4.58579 3.75 4.25 3.41421 4.25 3C4.25 2.58579 4.58579 2.25 5 2.25H19Z" />
      <path d="M11.5264 6.41797C11.8209 6.17766 12.2557 6.19512 12.5303 6.46973L18.5303 12.4697C18.8232 12.7626 18.8232 13.2374 18.5303 13.5303C18.2374 13.8232 17.7626 13.8232 17.4697 13.5303L12 8.06055L6.53027 13.5303C6.23738 13.8232 5.76262 13.8232 5.46973 13.5303C5.17683 13.2374 5.17683 12.7626 5.46973 12.4697L11.4697 6.46973L11.5264 6.41797Z" />
      <path d="M11.25 21V7C11.25 6.58579 11.5858 6.25 12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V21C12.75 21.4142 12.4142 21.75 12 21.75C11.5858 21.75 11.25 21.4142 11.25 21Z" />
    </SvgWrapper>
  );
}
